module.exports = __webpack_public_path__ + "img/ticket-star.2184328d.svg";